var render, staticRenderFns
import script from "./MainGlobeOperationFolder.vue?vue&type=script&lang=js&"
export * from "./MainGlobeOperationFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc90fa6",
  null
  
)

export default component.exports